import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { AuthShell } from "../features/auth/AuthShell";
import { SetPasswordDone } from "../features/auth/SetPasswordDone";
import "./PaymentResultPage.css";

// Loaded with a full page load right after the password is saved, so Apple's Smart App
// Banner (injected in index.html for this path only) appears here and nowhere else.
export default function AppReadyPage() {
  const { t } = useTranslation();
  return (
    <div className="payment-success-light bg-background text-foreground">
      <AuthShell title="HELCOO" testId="app-ready-card">
        <SetPasswordDone />
        <Link
          to="/login"
          className="mt-5 block text-center text-sm font-bold text-primary"
          data-testid="app-ready-login"
        >
          {t("reset.backToLogin")}
        </Link>
      </AuthShell>
    </div>
  );
}
